import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "background-decoration" }
const _hoisted_3 = { class: "floating-particles" }
const _hoisted_4 = { class: "login-container" }
const _hoisted_5 = { class: "login-card" }
const _hoisted_6 = { class: "login-form" }
const _hoisted_7 = { class: "form-actions" }

import { HpsfirProForm, HpsfirProFormItem, HpsfirBrand, useBaseUserStore, useRoute, useRouter } from 'hpsfir-managebase-ui';
import { ref } from 'vue';
import { onKeyStroke } from '@vueuse/core';
import { User } from '@element-plus/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const baseUserStore = useBaseUserStore();
const router = useRouter();
const route = useRoute();
const loading = ref(false);

// 版本信息
const packageVersion = process.env.VUE_APP_PACKAGE_VERSION;
const appVersion = process.env.VUE_APP_VERSION === 'test' ? '测试版' : '正式版';

const formRef = ref<InstanceType<typeof HpsfirProForm>>();
const loginFormItems: HpsfirProFormItem[] = [
  {
    name: 'userNameOrPhone',
    type: 'string',
    label: '账号',
    placeholder: '请输入用户名或手机号',
    rule: [{ required: true, message: '请输入账号' }],
  },
  {
    name: 'password',
    type: 'password',
    label: '密码',
    placeholder: '请输入密码',
    rule: [{ required: true, message: '请输入密码' }],
  },
];

const handleLogin = async(data: any) => {
  loading.value = true;
  try {
    await baseUserStore.login(data.userNameOrPhone, data.password);
    if (route.query.back) {
      await router.replace(route.query.back as string);
      return;
    }
    await router.replace('/');
  } finally {
    loading.value = false;
  }
};

onKeyStroke('Enter', () => {
  formRef.value?.submit();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gradient-bg" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (i) => {
          return _createElementVNode("div", {
            class: "particle",
            key: i
          })
        }), 64))
      ]),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"geometric-shapes\" data-v-23621fa4><div class=\"shape shape-1\" data-v-23621fa4></div><div class=\"shape shape-2\" data-v-23621fa4></div><div class=\"shape shape-3\" data-v-23621fa4></div><div class=\"shape shape-4\" data-v-23621fa4></div></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("h1", { class: "welcome-title" }, "欢迎登录"),
          _createElementVNode("p", { class: "welcome-subtitle" }, "QRWiFi 管理后台")
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(HpsfirProForm), {
            items: loginFormItems,
            "hide-cancel": "",
            "hide-ok": "",
            "hide-colon": "",
            "on-ok": handleLogin,
            ref_key: "formRef",
            ref: formRef,
            class: "form-container"
          }, null, 512),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "login-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (formRef.value?.submit())),
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "button-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(User))
                  ]),
                  _: 1
                }),
                _cache[3] || (_cache[3] = _createTextVNode(" 登录 ", -1))
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-footer" }, [
          _createElementVNode("p", { class: "footer-text" }, "安全登录 · 数据保护"),
          _createElementVNode("div", { class: "login-version" }, [
            _createElementVNode("span", { class: "version-main" }, "v1.0.0")
          ])
        ], -1))
      ])
    ]),
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"side-decoration\" data-v-23621fa4><div class=\"tech-circles\" data-v-23621fa4><div class=\"circle circle-1\" data-v-23621fa4></div><div class=\"circle circle-2\" data-v-23621fa4></div><div class=\"circle circle-3\" data-v-23621fa4></div></div><div class=\"tech-lines\" data-v-23621fa4><div class=\"line line-1\" data-v-23621fa4></div><div class=\"line line-2\" data-v-23621fa4></div><div class=\"line line-3\" data-v-23621fa4></div></div></div>", 1))
  ]))
}
}

})